import { Emphasis } from "@lya-protect/lya-protect-form-library/dist/UI";
import { InfoBulle } from "@src/components/infoBulle/InfoBulle";
import { InfoBulleButton } from "@src/components/infoBulleButton/InfoBulleButton";
import { PopperButton } from "@src/PopperButton";
import { formatCurrency } from "@src/utils";
import classNames from "classnames";
import { Card } from "../card/Card";
import "./recapCard.scss";

type RecapCardProps = {
  fullname: string;
  couvertureName: string;
  simulationCotisationMonth: number;
  className?: string;
};

export function RecapCard({
  className,
  fullname,
  couvertureName,
  simulationCotisationMonth,
}: RecapCardProps) {
  return (
    <Card className={classNames("recap-card", className)}>
      <p className="recap-card__first-recap">
        Pour une souscription au contrat Paxivie pour{" "}
        <Emphasis>{fullname}</Emphasis> avec un{" "}
        <Emphasis>{`${couvertureName.toLowerCase()} d'indemnisation`}</Emphasis>{" "}
        :
      </p>
      <p className="recap-card__second-recap">
        Votre cotisation s&apos;élèvera à{" "}
        <Emphasis>{`${formatCurrency(
          simulationCotisationMonth
        )} TTC par mois`}</Emphasis>
        ,
        <br />
        soit{" "}
        <Emphasis>{`${formatCurrency(
          simulationCotisationMonth * 12
        )} TTC par an.`}</Emphasis>
        <PopperButton
          popperPlacement="top-end"
          openOnHover
          withArrow
          renderButton={(props) => (
            <InfoBulleButton size="large" {...props}>
              {" "}
            </InfoBulleButton>
          )}
          renderPopperContent={({ setVisible }) => (
            <InfoBulle
              className="recap-card__info-bulle"
              onCancel={() => setVisible(false)}
            >
              Tarifs en vigueur valables jusqu&apos;au 30/11/2026, hors offre
              promotionnelle, sous réserve de toute évolution.
            </InfoBulle>
          )}
        />
      </p>
      <p>
        <br />
        Ce tarif comprend les garanties suivantes :{" "}
        <PopperButton
          popperPlacement="top-end"
          openOnHover
          withArrow
          renderButton={(props) => (
            <InfoBulleButton size="large" {...props}>
              {" "}
            </InfoBulleButton>
          )}
          renderPopperContent={({ setVisible }) => (
            <InfoBulle
              className="recap-card__info-bulle"
              onCancel={() => setVisible(false)}
            >
              Le contrat Paxivie est distribué par Tutélaire, Mutuelle soumise
              aux dispositions du livre Il du Code de la mutualité, dont le
              siège social est situé au 157 avenue de France - 75013 Paris et
              immatriculée sous le numéro Siren 775 682 164. La garantie des
              atteintes à l&apos;intégrité physique et psychique en cas
              d&apos;accident de la vie courante et la garantie en cas de décès
              accidentel sont assurées et réalisées par Tutélaire.
              <br />
              Les garanties d&apos;assistance au contrat Paxivie sont assurées
              et réalisées par Ressources Mutuelles Assistance, syndicat
              d&apos;assistance soumise aux dispositions du Livre Il du Code de
              la mutualité, dont le siège social est situé au 46 rue du Moulin -
              CS 92443, 44120 Vertou et immatriculée sous le numéro Siren 444
              269 682.
            </InfoBulle>
          )}
        />
        <ul>
          <li>
            Indemnisation dès 1% d&apos;atteinte à l&apos;intégrité psychique et
            physique faisant suite à un accident de la vie courante
          </li>
          <li>Allocation temporaire en cas de décès accidentel</li>
          <li>Assistance</li>
        </ul>
      </p>
    </Card>
  );
}
